import { render, staticRenderFns } from "./customDashboardConfig.vue?vue&type=template&id=28850d11&scoped=true"
import script from "./customDashboardConfig.vue?vue&type=script&lang=js"
export * from "./customDashboardConfig.vue?vue&type=script&lang=js"
import style0 from "./customDashboardConfig.vue?vue&type=style&index=0&id=28850d11&prod&lang=scss"
import style1 from "./customDashboardConfig.vue?vue&type=style&index=1&id=28850d11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28850d11",
  null
  
)

export default component.exports